import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { useDispatch } from 'react-redux'
import { BOOLEAN, DATE, FLOAT, NUMBER, SANDRE, STRING, SUBREQUEST } from 'utils/UserUtil'
import Input from 'components/forms/Input'
import NumberField from 'components/forms/NumberField'
import MultiAutocomplete from 'components/forms/MultiAutocomplete'
import useSandreList from 'utils/customHook/useSandreList'
import { useEffect } from 'react'
import UserAction from 'administration/components/user/actions/UserAction'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import DtoFilterParam from 'station/dto/DtoFilterParam'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import ToastrAction from 'toastr/actions/ToastrAction'
import RadioButtons from 'components/forms/RadioButtons'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'

const validRadioElements = [
    { code: 'true', name: 'yes' },
    { code: 'not true', name: 'no' },
]

const FilterParam = ({
    param = {},
    setParam = () => {},
}) => {
    const sandreList = useSandreList(param.sandreCode || '')
    const dispatch = useDispatch()
    const [list, setList] = useState([])

    useEffect(() => {
        if (param.subRequest) {
            dispatch(UserAction.getFilterParamList(param.subRequest)).then(json => setList(json || []))
        }
    }, [])

    return (
        <StyledFieldSet>
            <StyledLegend className='clickable' onClick={() => setParam({ filterResult: !param.filterResult })}>
                <Grid
                    container
                    alignItems='center'
                >
                    { param.filterResult ? <FilterAltIcon /> : <FilterAltOffIcon /> }
                    {param.parameterName}
                </Grid>
            </StyledLegend>
            <Grid container justifyContent='space-around' alignItems='center'>
                <Grid size={11}>
                    {param.filterType === NUMBER && (
                        <NumberField
                            value={parseInt(param?.value)}
                            onChange={v => setParam({ value: `${v}` })}
                            disabled={!param.filterResult}
                        />
                    )}
                    {param.filterType === FLOAT && (
                        <NumberField
                            value={parseFloat(param?.value)}
                            onChange={v => setParam({ value: `${v}` })}
                            floatValue
                            disabled={!param.filterResult}
                        />
                    )}
                    {param.filterType === SANDRE && (
                        <MultiAutocomplete
                            elements={sandreList}
                            clearFunction
                            values={param.value?.split(',').flatMap(d => parseInt(d))}
                            onChange={(values) => {
                                setParam({ value: values.length && values.join(',') || undefined })
                            }}
                            disabled={!param.filterResult}
                        />
                    )}
                    {param.filterType === BOOLEAN && (
                        <>
                            <RadioButtons
                                elements={validRadioElements.map(d => ({ ...d, name: i18n[d.name] }))}
                                selected={ param.value }
                                onChange={value => setParam({ value })}
                                disabled={!param.filterResult }
                            />
                        </>
                    )}
                    {param.filterType === STRING && (
                        <Input
                            value={param.value}
                            onChange={value => setParam({ value })}
                            disabled={!param.filterResult}
                        />
                    )}
                    {param.filterType === SUBREQUEST && (
                        <MultiAutocomplete
                            elements={list}
                            clearFunction
                            values={param.value?.split(',')}
                            onChange={values => setParam({ value: values.length && values.join(',') || undefined })}
                            disabled={!param.filterResult}
                        />
                    )}
                    {param.filterType === DATE && (
                        <SimpleDatePicker
                            label={' '}
                            value={parseInt(param?.value)}
                            onChange={v => setParam({ value: `${v}` })}
                            disabled={!param.filterResult}
                        />
                    )}
                </Grid>
            </Grid>
        </StyledFieldSet>
    )
}

FilterParam.propTypes = {
    param: PropTypes.instanceOf(DtoFilterParam),
    setParam: PropTypes.func,
}

const FilterDialog = ({
    parameters = [],
    isOpen = () => { },
    setIsOpen = () => { },
    launchSearch = () => { },
}) => {
    const dispatch = useDispatch()
    const [stateParameters, setStateParameters] = useState(parameters)

    const setParam = (param) => {
        setStateParameters(params => params.map(lp => lp.order === param.order ? param : lp))
    }

    const checkLaunch = () => {
        if (stateParameters.every(p => !p.filterResult || (p.filterResult && p.value))) {
            setIsOpen(false)
            launchSearch(stateParameters)
        } else {
            dispatch(ToastrAction.warning(i18n.pleaseCompleteAllRequiredField))
        }
    }

    return (
        <Dialog open={isOpen} fullWidth maxWidth='md'>
            <DefaultDialogTitle title={i18n.criteriaFilter} onClose={() => setIsOpen(false)}/>
            <DialogContent sx={{ paddingBottom: '200px' }}>
                {
                    stateParameters.map(param => {
                        return (
                            <FilterParam key={param} param={param} setParam={value => setParam(new DtoFilterParam({ ...param, ...value }))} />
                        )
                    })
                }
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    onClick={checkLaunch}
                >
                    {i18n.apply}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

FilterDialog.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterParam)),
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    launchSearch: PropTypes.func,
}

export default FilterDialog